import { render, staticRenderFns } from "./view-template.vue?vue&type=template&id=2c3aa2d8&scoped=true"
import script from "./view-template.vue?vue&type=script&lang=js"
export * from "./view-template.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c3aa2d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\WebBuild\\teamCity\\buildAgent\\work\\f0b2174a44415a20\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c3aa2d8')) {
      api.createRecord('2c3aa2d8', component.options)
    } else {
      api.reload('2c3aa2d8', component.options)
    }
    module.hot.accept("./view-template.vue?vue&type=template&id=2c3aa2d8&scoped=true", function () {
      api.rerender('2c3aa2d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/template/template/view-template.vue"
export default component.exports